import { isHttpError } from '../client/index.js';
import WebRequest from '../client/WebRequest.js';
export var GetPaymentLinkForOrder;
(function (GetPaymentLinkForOrder) {
    async function api(client, orderId) {
        const request = WebRequest.GET(`/patient-api/orders/${orderId}/payment-link`);
        return client.execute(request);
    }
    GetPaymentLinkForOrder.api = api;
    function mutation(client) {
        return {
            mutationFn: async (orderId) => await api(client, orderId),
            mutationKey: ['get-payment-link-for-order'],
        };
    }
    GetPaymentLinkForOrder.mutation = mutation;
})(GetPaymentLinkForOrder || (GetPaymentLinkForOrder = {}));
// The charge's checkout was already paid; the payment issue clears once Stripe confirms it.
export function isPaymentAlreadyReceivedError(error) {
    return (isHttpError(error) &&
        error.status === 409 &&
        error.response?.error === 'PAYMENT_ALREADY_RECEIVED');
}
// Checkout for a refill or yearly review whose charge failed.
export var GetPaymentLinkForRefill;
(function (GetPaymentLinkForRefill) {
    async function api(client, consultationReference) {
        const request = WebRequest.GET(`/patient-api/treatment-consultations/${consultationReference}/payment-link`);
        return client.execute(request);
    }
    GetPaymentLinkForRefill.api = api;
    function mutation(client) {
        return {
            mutationFn: async (consultationReference) => await api(client, consultationReference),
            mutationKey: ['get-payment-link-for-refill'],
        };
    }
    GetPaymentLinkForRefill.mutation = mutation;
})(GetPaymentLinkForRefill || (GetPaymentLinkForRefill = {}));
export var GetPaymentLinkForPaymentIssue;
(function (GetPaymentLinkForPaymentIssue) {
    async function api(client, issue) {
        if (issue.consultationReference) {
            return await GetPaymentLinkForRefill.api(client, issue.consultationReference);
        }
        return await GetPaymentLinkForOrder.api(client, issue.orderId);
    }
    GetPaymentLinkForPaymentIssue.api = api;
    function mutation(client) {
        return {
            mutationFn: async (issue) => await api(client, issue),
            mutationKey: ['get-payment-link-for-payment-issue'],
        };
    }
    GetPaymentLinkForPaymentIssue.mutation = mutation;
})(GetPaymentLinkForPaymentIssue || (GetPaymentLinkForPaymentIssue = {}));
